import React, {useEffect} from 'react';

/* This Hook can be used for detecting clicks outside the Opened Menu */
export function clickOutside(ref, onClickOutside) {
   useEffect(() => {
     function handleClickOutside(event) {
       if (ref && ref.current && !ref.current.contains(event.target)) {
         onClickOutside();
       }
     }
     document.addEventListener("click", handleClickOutside);
     return () => {
       document.removeEventListener("click", handleClickOutside);
     };
   }, [ref, onClickOutside]);
}